import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_czxv7ugga8: FaireBrandEntity = {
  token: "b_czxv7ugga8",
  type: "brand",
  name: "Happy Healthy Hippie",
  avatarUrl:
    "https://cdn.faire.com/fastly/190d9bf01664bf80ca5548905b6d7d6de7f868a23a578c2621d7fd316096e01d.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/c70e5197e9c9654e5a2ed4563b9cb76f5646aca019bfc4ace25648456a8c949c.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/190d9bf01664bf80ca5548905b6d7d6de7f868a23a578c2621d7fd316096e01d.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c70e5197e9c9654e5a2ed4563b9cb76f5646aca019bfc4ace25648456a8c949c.jpeg",
  location: "San Diego, CA, USA",
  minimumOrderDollars: 0,
  rating: 4.9,
  reviewCount: 59,
  isTopShop: true,
  isInsider: true,
  description:
    "We believe that happiness is a result of a life well lived and that a crucial component of life well lived is your health. Happy Healthy Hippie was born out of our passion for living intentionally, healthily, and soaking up the simple wonders of this world. This includes the gifts of nutrient filled plants that the Earth provides us with! We believe that beauty lies in simplicity, which is why our products are simple, natural, safe, and curated with intentionality.\n\nKylie’s knowledge and experience as a mental health psychotherapist has been poured into Happy Healthy Hippie. Each product has been crafted with total wellness in mind; mental, physical, emotional, and spiritual. Keio, born and raised in Bali, has a natural born connection to clean and simple living. These have become the core values of our company.\n\nTogether we have learned from one another and we have created a lifestyle that we are proud of and that we believe in. So much so that we created Happy Healthy Hippie so that we could share the Wellness of the Earth with you.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:34.920Z",
    importedBy: "entity-db-cli",
  },
};
